import { palette, transition } from '../../styles/tokens';

export type LensPillValue = 'calendar' | 'crew' | 'route';

interface LensPillOption {
  value: LensPillValue;
  label: string;
}

interface LensPillProps {
  value: LensPillValue;
  options: LensPillOption[];
  onChange: (next: LensPillValue) => void;
}

export function LensPill({ value, options, onChange }: LensPillProps) {
  return (
    <div
      style={{
        display: 'flex',
        gap: 2,
        background: palette.g100,
        borderRadius: 999,
        padding: 2,
      }}
    >
      {options.map((option) => {
        const active = option.value === value;
        return (
          <button
            key={option.value}
            onClick={() => onChange(option.value)}
            style={{
              border: 'none',
              borderRadius: 999,
              padding: '6px 12px',
              fontSize: 12,
              fontWeight: 600,
              cursor: 'pointer',
              fontFamily: 'inherit',
              transition: `all ${transition.fast}`,
              background: active ? palette.g800 : 'transparent',
              color: active ? palette.white : palette.g600,
            }}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
